import crypto from 'crypto'

const encryptDES = (message, key = '2L+/Iziq') => {
	key = key.length >= 8 ? key.slice(0, 8) : key.concat('0'.repeat(8 - key.length))
	const keyHex = Buffer.from(key)
	const cipher = crypto.createCipheriv('des-cbc', keyHex, keyHex)
	let c = cipher.update(`${message}`, 'utf8', 'base64')
	c += cipher.final('base64')
	return c
}

// DES 解密
const decryptDES = (text, key = '2L+/Iziq') => {
	key = key.length >= 8 ? key.slice(0, 8) : key.concat('0'.repeat(8 - key.length))
	const keyHex = Buffer.from(key)
	const cipher = crypto.createDecipheriv('des-cbc', keyHex, keyHex)
	let c = cipher.update(text, 'base64', 'utf8')
	c += cipher.final('utf8')
	return c
}

export { encryptDES, decryptDES }